import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.employeeProfileValidation = function () {
    const dictonary = {
      custom: {
        staffId: {
          required: () => t.t(dictEnum.LBL_Staff) + t.t(dictEnum.WARN_IsRequired)
        },
        staffType: {
          required: () => t.t(dictEnum.LBL_StaffType) + t.t(dictEnum.WARN_IsRequired)
        },
        staffEng: {
          required: () => t.t(dictEnum.LBL_EngName) + t.t(dictEnum.WARN_IsRequired)
        },
        last: {
          required: () => t.t(dictEnum.LBL_LastName) + t.t(dictEnum.WARN_IsRequired)
        },
        chiName: {
          required: () => t.t(dictEnum.LBL_ChiName) + t.t(dictEnum.WARN_IsRequired)
        },
        chiLastName: {
          required: () => t.t(dictEnum.LBL_LastName) + t.t(dictEnum.WARN_IsRequired)
        },
        docNum: {
          required: () => t.t(dictEnum.LBL_DocNum) + t.t(dictEnum.WARN_IsRequired)
        },
        docTypeCode: {
          required: () => t.t(dictEnum.LBL_IDDoc) + t.t(dictEnum.WARN_IsRequired)
        },
        companyName: {
          required: () => t.t(dictEnum.LBL_Company) + t.t(dictEnum.WARN_IsRequired)
        },
        gender: {
          required: () => t.t(dictEnum.LBL_Gender) + t.t(dictEnum.WARN_IsRequired)
        },
        emailId: {
          email: () => t.t(dictEnum.MSG_ValidEmail),
          required: () => t.t(dictEnum.LBL_Email) + t.t(dictEnum.WARN_IsRequired)
        },
        badgeNum: {
          required: () => t.t(dictEnum.LBL_StaffBadge) + t.t(dictEnum.WARN_IsRequired)
        },
        pwd: {
          is: () => t.t(dictEnum.WARN_PasswordNotMatch),
          required: () => t.t(dictEnum.LBL_Password) + t.t(dictEnum.WARN_IsRequired)
        },
        lang: {
          required: () => t.t(dictEnum.LBL_Language) + t.t(dictEnum.WARN_IsRequired)
        },
        newPwd: {
          is: () => t.t(dictEnum.WARN_PasswordNotMatch),
          required: () =>
            t.t(dictEnum.LBL_ConfirmNewPw) + t.t(dictEnum.WARN_IsRequired)
        }
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmployeeProfileValidation.js